"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMMENT_START_IN_RAWS_BETWEEN_REGEX = exports.SELECTOR_STATE_REGEX = exports.PROPS_SUPPORTING_COMMENTS = exports.DEFAULT_FILTER = void 0;
var DEFAULT_FILTER = function (_) { return true; };
exports.DEFAULT_FILTER = DEFAULT_FILTER;
exports.PROPS_SUPPORTING_COMMENTS = ['background', 'box-shadow', 'text-shadow'];
exports.SELECTOR_STATE_REGEX = /.*[^:]:([^:]*)$/;
exports.COMMENT_START_IN_RAWS_BETWEEN_REGEX = /^:\s*\/\*/;
//# sourceMappingURL=stylable-aggregation-constants.js.map